<template>
 <v-expansion-panels accordion class="mx-3 mt-0" :value="0">
      <v-expansion-panel class="mt-10" style="background-color: transparent !important">
          <v-expansion-panel-header class="text-uppercase text-center">Advanced settings</v-expansion-panel-header>
          <v-expansion-panel-content>
<form name="form1">

<table>
<tr><td>Serial:</td><td><input type="text" name="serial1" value="76" size="40"/></td></tr>
<tr><td>Subjec DN:</td><td><input type="text" name="subject1" value="/C=US/CN=Test User1" size="80"/></td></tr>
</table>
<br/>
<hr/>
<h4>(Step 1) Fill CA private key (PEM formatted PKCS#5 RSA key) and passcode</h4>
<textarea name="cakey1" cols="65" rows="6" v-model="valuePem"></textarea>
<br/>
CA KEY PASSCODE(=hoge): <input type="password" name="cakeypass1" value="hoge" size="0"/> 
<br/>

<!-- ============================================================== -->

<h4>(Step 2) Fill Issuing Certificate Fields</h4>
<table>
<tr><td>Issuer DN:</td><td><input  type="text" name="issuer1" value="/C=US/O=JS-TEST-CA" size="80"/></td></tr>
<tr><td>Validity:</td><td>
From <input type="text" name="notbefore1" value="200501235959Z" size="20"/>
To <input type="text" name="notafter1" value="230501235959Z" size="20"/>
</td></tr>
<tr><td>Subject<br/>Public Key</td><td>
<textarea name="pubkey1" cols="65" rows="3">-----BEGIN PUBLIC KEY-----
MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAOtpGHibL8Ue+MXPPufkcrNES40rCT5L
RIU9MjTZ8/7owG5bAsiFA9Xxh3uZK1T5QA64jNJVbp2ojHAtNyWPuwsCAwEAAQ==
-----END PUBLIC KEY-----</textarea><br/>
NOTE: This shall be 'BEGIN PUBLIC KEY', not 'BEGIN RSA PUBLIC KEY'.</td></tr>
<tr><td colspan="2">
Basic Constraints: 
exists<input type="checkbox" name="bc_exists" value="1" checked/>
critical<input type="checkbox" name="bc_critical" value="1" checked/>
cAflag<input type="checkbox" name="bc_ca" value="1"/>
pathLen<input type="text" name="bc_pathlen" size="3"/>
</td></tr>
<tr><td colspan="2">
Key Usage: 
exists<input type="checkbox" name="ku_exists" value="1" checked/>
critical<input type="checkbox" name="ku_critical" value="1"/>
<br/>
<input type="checkbox" name="ku_0dsig" value="1" checked/> digitalSignature(0)
<input type="checkbox" name="ku_1nonrep" value="1"/> nonRepudiation(1)
<input type="checkbox" name="ku_2keyenc" value="1"/> keyEncipherment(2)<br/>
<input type="checkbox" name="ku_3datenc" value="1"/> dataEncipherment(3)
<input type="checkbox" name="ku_4keyagree" value="1"/> keyAgreement(4)
<input type="checkbox" name="ku_5keycertsign" value="1"/> keyCertSign(5)<br/>
<input type="checkbox" name="ku_6crlsign" value="1"/> keyEncipherment(6)
<input type="checkbox" name="ku_7enconly" value="1"/> encipherOnly(7)
<input type="checkbox" name="ku_8deconly" value="1"/> decipherOnly(8)<br/>
</td></tr>
<tr><td colspan="2">
Extended Key Usage:
exists<input type="checkbox" name="eku_exists" value="1"/>
critical<input type="checkbox" name="eku_critical" value="1"/>
<br/>
<input type="checkbox" name="eku_srv" value="1"/> serverAuth
<input type="checkbox" name="eku_cli" value="1"/> clientAuth
<input type="checkbox" name="eku_code" value="1"/> codeSigning
<input type="checkbox" name="eku_email" value="1"/> emailProtection
<input type="checkbox" name="eku_time" value="1"/> timeStamping
</td></tr>
<tr><td colspan="2">
CRL DistributionPoints: 
exists<input type="checkbox" name="cdp_exists" value="1" checked/>
critical<input type="checkbox" name="cdp_critical" value="1"/>
<br/>
URL<input type="text" name="cdp_uri" value="http://test.com/jsca.crl" size="80"/>
</td></tr>
</table>

<h4>(Step3) Press "Issue Certificate" button</h4>
<input type="button" value="Issue Certificate" onClick="doIssue();"/>
<input type="reset" name="reset" value="Reset"/>

<h2>Issued Certificate</h2>
<textarea name="newcert1"  cols="65" rows="8"></textarea>

</form>
<!--
  <v-form
    id="form1"
    v-model="valid"
    lazy-validation
  >
    <h3 class="my-5">(Step1) Fill CA private key (PEM formatted PKCS#5 RSA key) and passcode</h3>
    <v-textarea
        name="cakey1" cols="65" rows="6"
        label="Textarea"
        outlined
        value="-----BEGIN RSA PRIVATE KEY-----
Proc-Type: 4,ENCRYPTED
DEK-Info: DES-EDE3-CBC,4626F2E5853E783F

3vFpkrnbantC8RSzng2+jBw/VX95oi0VGKP0G8whENHUOVQXB/YOUSj+n80Y0Wwc
GpeQi8U0FQdWyYv8b9aioeFB06r9t9mJsYscJ/wcIvv5tTMkr89cwN3+4GQQuqNg
TmI9ekeoZ3NP26hTM4XTuFqHx4dzNNwjDLc8txc77WE/o4J4p8k9Py5yPZjs9EKy
wy/yxtqQYQuFj90OMEG1G89iHTZRcq4YTZYdqg6P/XEUvyjifN+7Nym8f2N9TDDn
RJtApPQlrgXvUDQKz6Lu1ZYMwe94E9YdutDGQMbxixbiyxlcxrkb/oEHH5WP5qPG
w/xzh08Ce2Ftba2Q860S8nznjyZFiv+lqSKBahbujgP/63ZL+JbAd4cYBqgm4g1C
YwMhHJbaVCzwYduxdyK2JBYEosDZiDfnOP4DqPhJYpg=
-----END RSA PRIVATE KEY-----"
    ></v-textarea>
    <v-text-field
      value="hoge"
      name="cakeypass1"
      :counter="4"
      label="CA KEY PASSCODE(=hoge)"
      type="password"
      required
    ></v-text-field>
    <v-col cols="12"><h3>(Step2) Fill Issuing Certificate Fields</h3></v-col>
    <v-row>
        <v-col cols="6">
            <v-text-field
            name="serial1"
            label="Serial"
            value="76" size="20"
            ></v-text-field>
        </v-col>
        <v-col cols="6">
            <v-text-field
            label="Issuer DN"
            name="issuer1" value="/C=US/O=JS-TEST-CA" size="80"
            ></v-text-field>
        </v-col>
        <v-col cols="12"><h4>Validity:</h4></v-col>
        <v-col cols="6">
            <v-text-field
            label="From"
            name="issuer1" value="130501235959Z" size="20"
            ></v-text-field>
        </v-col>
        <v-col cols="6">
            <v-text-field
            label="To"
            name="issuer1" value="230501235959Z" size="20"
            ></v-text-field>
        </v-col>
        <v-col cols="6">
            <v-text-field
            label="Subjec DN"
            name="subject1" value="/C=US/CN=Test User1" size="80"
            ></v-text-field>
        </v-col>
        <v-col cols="6">

    <v-textarea
        outlined
        hint="NOTE: This shall be 'BEGIN PUBLIC KEY', not 'BEGIN RSA PUBLIC KEY'."
        name="pubkey1" cols="65" rows="3"
        label="Subject Public Key"
        value="-----BEGIN PUBLIC KEY-----
MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAOtpGHibL8Ue+MXPPufkcrNES40rCT5L
RIU9MjTZ8/7owG5bAsiFA9Xxh3uZK1T5QA64jNJVbp2ojHAtNyWPuwsCAwEAAQ==
-----END PUBLIC KEY-----"
    ></v-textarea>
        </v-col>
    <v-col cols="12" class="ma-0 pa-0"><p class="ma-0 pa-0">Basic Constraints</p></v-col>
    <v-col cols="2">
        <v-checkbox
        label="exists"
        name="bc_exists" :value='true'
        ></v-checkbox>
    </v-col>
    <v-col cols="2">
        <v-checkbox
        label="critical"
        name="bc_critical" :value='true'
        ></v-checkbox>
    </v-col>
    <v-col cols="2">
        <v-checkbox
        label="cAflag"
        name="bc_ca" 
        ></v-checkbox>
    </v-col>
    <v-col cols="1">
        <v-text-field
        label="pathLen"
        name="bc_pathlen" size="3"
        ></v-text-field>
    </v-col>
   
    <v-col cols="12" class="ma-0 pa-0"><p class="ma-0 pa-0">Key Usage</p></v-col>
    <v-col cols="2">
    <v-checkbox
      label="exists"
      name="ku_critical"
    ></v-checkbox>
    </v-col>
    <v-col cols="2">
    <v-checkbox
      label="critical"
      required
    ></v-checkbox>
    </v-col>
    <v-col cols="12" class="ma-0 pa-0"></v-col>
    <v-col cols="2">

    <v-checkbox
      :value='true'
      label="digitalSignature(0)"
      name="ku_0dsig"
    ></v-checkbox>
    </v-col>
    <v-col cols="2">
    <v-checkbox
      label="nonRepudiation(1)"
      name="ku_1nonrep"
    ></v-checkbox>
    </v-col>
    <v-col cols="2">
    <v-checkbox
      label="keyEncipherment(2)"
      name="ku_2keyenc"
    ></v-checkbox>
    </v-col>
    <v-col cols="2">
    <v-checkbox
      label="dataEncipherment(3)"
      name="ku_3datenc"
    ></v-checkbox>
    </v-col>
    <v-col cols="2">
    <v-checkbox
      label="keyAgreement(4)"
      name="ku_4keyagree"
    ></v-checkbox>
    </v-col>
    <v-col cols="2">
    <v-checkbox
      label="keyCertSign(5)"
      name="ku_5keycertsign"
    ></v-checkbox>
    </v-col>
    <v-col cols="2">
    <v-checkbox
      label="keyEncipherment(6)"
      name="ku_6crlsign"
    ></v-checkbox>
    </v-col>
    <v-col cols="2">
    <v-checkbox
      label="encipherOnly(7) "
      name="ku_7enconly"
    ></v-checkbox>
    </v-col>
    <v-col cols="2">
    <v-checkbox
      label="decipherOnly(8)"
      name="ku_8deconly"
    ></v-checkbox>
    </v-col>
    <v-col cols="12" class="ma-0 pa-0"><p class="ma-0 pa-0">Extended Key Usage</p></v-col>
    <v-col cols="2">
    <v-checkbox
      value='true'
      label="exists"
      name="cdp_critical"
    ></v-checkbox>
    </v-col>
    <v-col cols="2">
    <v-checkbox
      label="critical"
      name="ku_8deconly"
    ></v-checkbox></v-col>
    <v-col cols="12" class="ma-0 pa-0"><p class="ma-0 pa-0">CRL DistributionPoints:</p></v-col>
    <v-col cols="2">
        <v-checkbox
        label="serverAuth"
        name="eku_srv"
        ></v-checkbox>
    </v-col>
    <v-col cols="2">
        <v-checkbox
        label="clientAuth"
        name="eku_cli"
        ></v-checkbox>
    </v-col>
    <v-col cols="2">
        <v-checkbox
        label="codeSigning"
        name="eku_code"
        ></v-checkbox>
    </v-col>
    <v-col cols="2">
        <v-checkbox
        label="emailProtection"
        name="eku_email"
        ></v-checkbox>
    </v-col>
    <v-col cols="2">
        <v-checkbox
        label="timeStamping"
        name="eku_time"
        ></v-checkbox>
    </v-col>
    <v-col cols="12" class="ma-0 pa-0"><p class="ma-0 pa-0">CRL DistributionPoints: </p></v-col>
    <v-col cols="2">
    <v-checkbox
      label="exists"
      name="cdp_exists"
      :value='true'
    ></v-checkbox>
    </v-col>
    <v-col cols="2">
    <v-checkbox
      label="critical"
      name="cdp_critical"
    ></v-checkbox>
    </v-col>
    <v-col cols="12">
    <v-text-field
      label="URL"
      name="cdp_uri" value="http://test.com/jsca.crl"
    ></v-text-field>
    </v-col>

    </v-row>
    <h3>(Step3) Press "Issue Certificate" button</h3>
    <v-btn
      :disabled="!valid"
      color="success"
      class="mr-4"
      @click="validate"
    >
      Issue Certificate
    </v-btn>

    <v-btn
      color="error"
      class="mr-4"
      @click="reset"
    >
      Reset
    </v-btn>

    <h3>Issued Certificate</h3>
   <v-textarea
        outlined
        name="newcert1"  cols="65" rows="8"
    ></v-textarea>
  </v-form>-->

          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
</template>
 
<script>
  export default {
    props: ["canI", "csr"],
    data: () => ({
      valid: true,
      valuePem:'',
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4',
      ],
      checkbox: false,
    }),
    mounted(){
      this.valuePem = '-----BEGIN RSA PRIVATE KEY-----/n'+
'Proc-Type: 4,ENCRYPTED'+
'DEK-Info: DES-EDE3-CBC,4626F2E5853E783F\n\n'+
'3vFpkrnbantC8RSzng2+jBw/VX95oi0VGKP0G8whENHUOVQXB/YOUSj+n80Y0Wwc\n'+
'GpeQi8U0FQdWyYv8b9aioeFB06r9t9mJsYscJ/wcIvv5tTMkr89cwN3+4GQQuqNg\n'+
'TmI9ekeoZ3NP26hTM4XTuFqHx4dzNNwjDLc8txc77WE/o4J4p8k9Py5yPZjs9EKy\n'+
'wy/yxtqQYQuFj90OMEG1G89iHTZRcq4YTZYdqg6P/XEUvyjifN+7Nym8f2N9TDDn\n'+
'RJtApPQlrgXvUDQKz6Lu1ZYMwe94E9YdutDGQMbxixbiyxlcxrkb/oEHH5WP5qPG\n'+
'w/xzh08Ce2Ftba2Q860S8nznjyZFiv+lqSKBahbujgP/63ZL+JbAd4cYBqgm4g1C\n'+
'YwMhHJbaVCzwYduxdyK2JBYEosDZiDfnOP4DqPhJYpg=\n'+
'-----END RSA PRIVATE KEY-----';

      var f1 = document.form1;
      f1.serial1.value = Math.random() * (10000000000000000);
    },


    methods: {
      resetValidation () {
        this.$refs.form.resetValidation()
      },
doIssue() {
    var f1 = document.form1;
    f1.newcert1.value = "issuing ...";
    var csr = this.csr;
    let o = KEYUTIL.getKeyFromCSRPEM(csr);
    f1.pubkey1.value = KEYUTIL.getPEM(o);

    // 1. generate TBSCertificate
    var tbsc = new KJUR.asn1.x509.TBSCertificate();
    tbsc.setSerialNumberByParam({'int': parseInt(f1.serial1.value)});
    tbsc.setSignatureAlgByParam({'name': 'SHA256withRSA'});
    tbsc.setIssuerByParam({'str': f1.issuer1.value});  
    tbsc.setNotBeforeByParam({'str': f1.notbefore1.value});
    tbsc.setNotAfterByParam({'str': f1.notafter1.value});
    tbsc.setSubjectByParam({'str': f1.subject1.value});  
    tbsc.setSubjectPublicKeyByParam({'rsapem': f1.pubkey1.value});

    if (f1.bc_exists.checked) {
      var param = {};
      param['critical'] = (f1.bc_critical.checked)? true : false;
      param['cA'] = (f1.bc_ca.checked)? true : false;
      if (f1.bc_pathlen.value != '') {
        param['pathLen'] = parseInt(f1.bc_pathlen.value);
      }
      tbsc.appendExtension(new KJUR.asn1.x509.BasicConstraints(param));
    }

    if (f1.ku_exists.checked) {
      var param = {};
      param['critical'] = (f1.ku_critical.checked)? true : false;
      var sBin = '';
      sBin += (f1.ku_0dsig.checked) ? "1" : "0";
      sBin += (f1.ku_1nonrep.checked) ? "1" : "0";
      sBin += (f1.ku_2keyenc.checked) ? "1" : "0";
      sBin += (f1.ku_3datenc.checked) ? "1" : "0";
      sBin += (f1.ku_4keyagree.checked) ? "1" : "0";
      sBin += (f1.ku_5keycertsign.checked) ? "1" : "0";
      sBin += (f1.ku_6crlsign.checked) ? "1" : "0";
      sBin += (f1.ku_7enconly.checked) ? "1" : "0";
      sBin += (f1.ku_8deconly.checked) ? "1" : "0";
      param['bin'] = sBin;
      tbsc.appendExtension(new KJUR.asn1.x509.KeyUsage(param));
    }

    if (f1.eku_exists.checked) {
      var param = {};
      var a = [];
      param.critical = (f1.eku_critical.checked) ? true : false;
      if (f1.eku_srv.checked)   a.push({name: 'serverAuth'});
      if (f1.eku_cli.checked)   a.push({name: 'clientAuth'});
      if (f1.eku_code.checked)  a.push({name: 'codeSigning'});
      if (f1.eku_email.checked) a.push({name: 'emailProtection'});
      if (f1.eku_time.checked)  a.push({name: 'timeStamping'});
      param.array = a;
      var ext = new KJUR.asn1.x509.ExtKeyUsage(param);
      tbsc.appendExtension(ext);
    }

    if (f1.cdp_exists.checked && f1.cdp_uri.value != '') {
      var param = {};
      param['critical'] = (f1.cdp_critical.checked)? true : false;
      param['uri'] = f1.cdp_uri.value;
      tbsc.appendExtension(new KJUR.asn1.x509.CRLDistributionPoints(param));
    }

    // generate and sign certificate
    var caKey = KEYUTIL.getKey.apply(null, [f1.cakey1.value, f1.cakeypass1.value]);
    var cert = new KJUR.asn1.x509.Certificate({tbscertobj: tbsc,
                                              prvkeyobj: caKey});
    cert.sign();
    f1.newcert1.value = cert.getPEMString();
    this.$emit("setPKCS7", f1.newcert1.value)
  }

    },
  }
</script>